"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4548],{

/***/ 39361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bG": function() { return /* reexport */ scrollSection_ScrollingProvider; },
  "$0": function() { return /* reexport */ scrollSection_Section; },
  "ce": function() { return /* reexport */ useScrollWithSections; }
});

// UNUSED EXPORTS: ScrollContext

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./common/bit/scrollSection/context.ts

var DEFAULT_CONTEXT = {
    selected: "",
    refs: {},
    scrollTo: function() {},
    registerRef: function() {
        return null;
    }
};
var ScrollContext = (0,react.createContext)(DEFAULT_CONTEXT);
var Consumer = ScrollContext.Consumer, Provider = ScrollContext.Provider;

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/smoothscroll-polyfill/dist/smoothscroll.js
var smoothscroll = __webpack_require__(30523);
var smoothscroll_default = /*#__PURE__*/__webpack_require__.n(smoothscroll);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./common/bit/scrollSection/utils.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var debounce = function(func, waitFor) {
    var timeout = null;
    var debounced = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (timeout !== null) {
            clearTimeout(timeout);
            timeout = null;
        }
        timeout = setTimeout(function() {
            return func.apply(void 0, (0,_to_consumable_array/* default */.Z)(args));
        }, waitFor);
    };
    return debounced;
};

;// CONCATENATED MODULE: ./common/bit/scrollSection/ScrollingProvider.tsx






if (true) {
    smoothscroll_default().polyfill();
}
var ScrollingProvider = function(param) {
    var _debounceDelay = param.debounceDelay, debounceDelay = _debounceDelay === void 0 ? 20 : _debounceDelay, _scrollBehavior = param.scrollBehavior, scrollBehavior = _scrollBehavior === void 0 ? "smooth" : _scrollBehavior, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, children = param.children;
    var ref = (0,react.useState)(""), selected = ref[0], setSelected = ref[1];
    var REFS = (0,react.useMemo)(function() {
        return {};
    }, []);
    var query = (0,router.useRouter)().query;
    (0,react.useEffect)(function() {
        Object.keys(REFS).forEach(function(acc) {
            var ref;
            if (((ref = REFS[acc]) === null || ref === void 0 ? void 0 : ref.current) == null) {
                delete REFS[acc];
            }
        });
    }, [
        query
    ]);
    (0,react.useEffect)(function() {
        document.addEventListener("scroll", debounceScroll, true);
        var id = location.hash.replace(/^#/, "");
        var sectionRef = REFS[decodeURI(id)];
        if (sectionRef) {
            var top = sectionRef.current.offsetTop + offset;
            window.scrollTo({
                top: top,
                behavior: "auto"
            });
            if (selected !== id) {
                window.history.replaceState(history.state, null, "#".concat(id));
                setSelected(id);
            }
        } else {
            handleScroll();
        }
        return function() {
            document.removeEventListener("scroll", debounceScroll, true);
        };
    }, []);
    var handleScroll = function() {
        var selectedSection = Object.keys(REFS).reduce(function(acc, id) {
            var element = REFS[id].current;
            if (!element) return acc;
            var ref = element.getBoundingClientRect(), top = ref.top, bottom = ref.bottom;
            if (top > offset + 100 || bottom < offset + 100) return acc;
            if (top <= acc.top) return {
                top: top,
                id: id
            };
            return acc;
        }, {
            top: 9999,
            id: ""
        });
        if (selected !== selectedSection.id) {
            var newHash = "#".concat(selectedSection.id);
            if (window.location.hash !== newHash) {
                window.history.replaceState(history.state, null, newHash);
            }
            setSelected(selectedSection.id);
        }
    };
    var debounceScroll = debounce(handleScroll, debounceDelay);
    var registerRef = function(id) {
        var ref = /*#__PURE__*/ (0,react.createRef)();
        REFS[id] = ref;
        return ref;
    };
    var scrollTo = function(section) {
        var sectionRef = REFS[section];
        if (!sectionRef) return console.warn("Section ID not recognized!");
        var top = sectionRef.current.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset;
        var newHash = "#".concat(section);
        if (window.location.hash !== newHash) {
            window.history.replaceState(history.state, null, section ? newHash : "");
        }
        setSelected(section);
        window.scrollTo({
            top: top,
            behavior: scrollBehavior
        });
    };
    var value = (0,react.useMemo)(function() {
        return {
            registerRef: registerRef,
            scrollTo: scrollTo,
            refs: REFS,
            selected: selected
        };
    }, [
        selected,
        REFS
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider, {
        value: value,
        children: children
    });
};
/* harmony default export */ var scrollSection_ScrollingProvider = (ScrollingProvider);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./common/bit/scrollSection/Section.tsx






var Section = function(_param) {
    var id = _param.id, title = _param.title, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "title",
        "children"
    ]);
    var registerRef = (0,react.useContext)(ScrollContext).registerRef;
    var ref = (0,react.useMemo)(function() {
        return registerRef(id);
    }, [
        id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        ref: ref,
        "data-title": title,
        id: id,
        children: children
    }));
};
/* harmony default export */ var scrollSection_Section = (Section);

;// CONCATENATED MODULE: ./common/bit/scrollSection/useScrollSection.ts


var useScrollWithSections = function() {
    var ref = (0,react.useContext)(ScrollContext), scrollTo = ref.scrollTo, selected = ref.selected, refs = ref.refs;
    var selectedSectionItem = {
        title: ""
    };
    var sections = Object.keys(refs).map(function(id) {
        var item = {
            id: id,
            title: refs[id].current.dataset.title,
            onClick: function() {
                return scrollTo(id);
            },
            selected: selected === id
        };
        if (selected === id) selectedSectionItem = item;
        return item;
    });
    return {
        selected: selected,
        sections: sections,
        selectedSectionItem: selectedSectionItem
    };
};

;// CONCATENATED MODULE: ./common/bit/scrollSection/index.ts







/***/ }),

/***/ 63269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ navigation_CarModelNavBar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AppBar/AppBar.js
var AppBar = __webpack_require__(45258);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Toolbar/Toolbar.js
var Toolbar = __webpack_require__(28358);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./common/analytics.ts + 10 modules
var analytics = __webpack_require__(87018);
// EXTERNAL MODULE: ./common/bit/scrollSection/index.ts + 5 modules
var scrollSection = __webpack_require__(39361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./reusable/ButtonBaseBlank.tsx
var ButtonBaseBlank = __webpack_require__(59041);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(55517);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(1518);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(22038);
;// CONCATENATED MODULE: ./components/carModelPage/navigation/CarModelSideDrawer.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .MuiPaper-root {\n    padding-top: ",
        "px;\n    padding-bottom: 32px;\n    background-color: ",
        ";\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);\n  }\n  .MuiBackdrop-root {\n    background-color: rgba(0, 0, 0, 0.4);\n  }\n  z-index: ",
        " !important;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background-color: ",
        ";\n  height: 0.5px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 20px;\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  p {\n    color: ",
        ";\n    font-weight:300;\n  }\n  &:hover {\n    p {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var StyledDrawer = (0,styled_components_browser_esm/* default */.ZP)(Drawer/* default */.ZP).withConfig({
    displayName: "CarModelSideDrawer__StyledDrawer",
    componentId: "sc-feefac8d-0"
})(_templateObject(), shared/* HEADER_ANIME_M */.yv, function(p) {
    return p.theme.colors.headerColor;
}, function(p) {
    return p.theme.zIndex.appBar - 20;
});
var StyledDrawerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CarModelSideDrawer__StyledDrawerWrapper",
    componentId: "sc-feefac8d-1"
})(_templateObject1());
var StyledDivider = (0,styled_components_browser_esm/* default */.ZP)(Divider/* default */.Z).withConfig({
    displayName: "CarModelSideDrawer__StyledDivider",
    componentId: "sc-feefac8d-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.darkGrey;
});
var StyledLinkButton = (0,styled_components_browser_esm/* default */.ZP)(ButtonBaseBlank/* default */.Z).withConfig({
    displayName: "CarModelSideDrawer__StyledLinkButton",
    componentId: "sc-feefac8d-3"
})(_templateObject3(), function(p) {
    return p.$selected ? p.theme.colors.white : p.theme.colors.darkGrey;
});
var CarModelSideDrawer = function(param) {
    var isOpen = param.isOpen, toggleDrawer = param.toggleDrawer;
    var sections = (0,scrollSection/* useScrollWithSections */.ce)().sections;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDrawer, {
        anchor: "top",
        open: isOpen,
        onClose: toggleDrawer(false),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDrawerWrapper, {
            role: "presentation",
            onKeyDown: toggleDrawer(false),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDivider, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledCol */.N6, {
                    $gap: "20px",
                    $notCenter: true,
                    $fullWidth: true,
                    $mt: "20px",
                    children: sections.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkButton, {
                                onClick: function(e) {
                                    item.onClick();
                                    toggleDrawer(false)(e);
                                },
                                $selected: item.selected,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyRtl */.UE, {
                                    variant: "body1",
                                    $color: colors/* default.borderGrey */.Z.borderGrey,
                                    children: item.title
                                })
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var navigation_CarModelSideDrawer = (CarModelSideDrawer);

;// CONCATENATED MODULE: ./components/carModelPage/navigation/CarModelNavBar.tsx

function CarModelNavBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  background-color: ",
        ";\n  top: 0px;\n  border-top: 1px solid rgba(153, 153, 153, 1);\n\n  ",
        " {\n    border-top: 3px solid rgba(153, 153, 153, 1);\n  }\n"
    ]);
    CarModelNavBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CarModelNavBar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* margin-top: 112px; */\n  height: ",
        "px;\n  transition: height 0.33s linear;\n  ",
        " {\n    height: ",
        "px;\n  }\n"
    ]);
    CarModelNavBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CarModelNavBar_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n  justify-content: space-between;\n  min-height: auto;\n  align-items: center;\n"
    ]);
    CarModelNavBar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CarModelNavBar_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-transform: uppercase;\n  font-weight: 300;\n"
    ]);
    CarModelNavBar_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: ",
        ";\n  display: inline-block;\n  transform: 0.4s linear;\n  width: 18px;\n  height: 18px;\n  margin-right: 4px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  p {\n    color: ",
        ";\n    font-weight: 300;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}










var StyledAppBar = (0,styled_components_browser_esm/* default */.ZP)(AppBar/* default */.Z).withConfig({
    displayName: "CarModelNavBar__StyledAppBar",
    componentId: "sc-41c2381d-0"
})(CarModelNavBar_templateObject(), function(p) {
    return p.theme.colors.headerColor;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(shared/* HomePageContainer */.Ts).withConfig({
    displayName: "CarModelNavBar__StyledContainer",
    componentId: "sc-41c2381d-1"
})(CarModelNavBar_templateObject1(), shared/* HEADER_ANIME_M */.yv, function(p) {
    return p.theme.breakpoints.up("md");
}, shared/* HEADER_ANIME_D */.oe);
var StyledToolbar = (0,styled_components_browser_esm/* default */.ZP)(Toolbar/* default */.Z).attrs({
    disableGutters: true
}).withConfig({
    displayName: "CarModelNavBar__StyledToolbar",
    componentId: "sc-41c2381d-2"
})(CarModelNavBar_templateObject2());
var StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "CarModelNavBar__StyledText",
    componentId: "sc-41c2381d-3"
})(CarModelNavBar_templateObject3(), function(p) {
    return p.theme.colors.borderGrey;
});
var StyledSvgArrow = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "CarModelNavBar__StyledSvgArrow",
    componentId: "sc-41c2381d-4"
})(_templateObject4(), function(p) {
    return p.$rotateUp ? "rotate(180deg)" : "rotate(0deg)";
});
var CarModelNavBar_StyledLinkButton = (0,styled_components_browser_esm/* default */.ZP)(ButtonBaseBlank/* default */.Z).withConfig({
    displayName: "CarModelNavBar__StyledLinkButton",
    componentId: "sc-41c2381d-5"
})(_templateObject5(), function(p) {
    return p.$selected ? p.theme.colors.white : p.theme.colors.darkGrey;
});
var CarModelNavBar = function(param) {
    var modelName = param.modelName, className = param.className;
    var ref = (0,scrollSection/* useScrollWithSections */.ce)(), sections = ref.sections, selectedSectionItem = ref.selectedSectionItem;
    var ref1 = (0,react.useState)(false), isDrawerOpen = ref1[0], setIsDrawerOpen = ref1[1];
    var toggleDrawer = function(open) {
        return function(event) {
            if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
                return;
            }
            setIsDrawerOpen(open);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAppBar, {
                component: "div",
                className: className,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledToolbar, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledRow */.N0, {
                                    $gap: "80px",
                                    children: sections.map(function(item, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarModelNavBar_StyledLinkButton, {
                                                onClick: function() {
                                                    item.onClick();
                                                    (0,analytics/* trackSubmenuModelPageClicks */.A$)();
                                                },
                                                $selected: item.selected,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyRtl */.UE, {
                                                    variant: "body1",
                                                    children: item.title
                                                })
                                            })
                                        }, i);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBaseBlank/* default */.Z, {
                                    onClick: toggleDrawer(!isDrawerOpen),
                                    "aria-label": "פתיחת תפריט צד",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                                            children: selectedSectionItem === null || selectedSectionItem === void 0 ? void 0 : selectedSectionItem.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSvgArrow, {
                                            src: "/icons/fi_chevron-down_white.svg",
                                            alt: "downArrow",
                                            $rotateUp: isDrawerOpen
                                        })
                                    ]
                                })
                            }),
                            modelName && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                                children: modelName
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_CarModelSideDrawer, {
                    isOpen: isDrawerOpen,
                    toggleDrawer: toggleDrawer
                })
            })
        ]
    });
};
/* harmony default export */ var navigation_CarModelNavBar = (CarModelNavBar);


/***/ }),

/***/ 97294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$L": function() { return /* binding */ StyledHeaderSubtitle; },
/* harmony export */   "$v": function() { return /* binding */ StyledTh; },
/* harmony export */   "EF": function() { return /* binding */ StyledLi; },
/* harmony export */   "Fg": function() { return /* binding */ StyledLink; },
/* harmony export */   "GI": function() { return /* binding */ StyledTd; },
/* harmony export */   "PW": function() { return /* binding */ StyledSmallText; },
/* harmony export */   "SG": function() { return /* binding */ StyledThead; },
/* harmony export */   "TK": function() { return /* binding */ StyledSubtitle; },
/* harmony export */   "ZN": function() { return /* binding */ StyledBody2; },
/* harmony export */   "aG": function() { return /* binding */ StyledTr; },
/* harmony export */   "eX": function() { return /* binding */ StyledH3; },
/* harmony export */   "hc": function() { return /* binding */ StyledUl; },
/* harmony export */   "k6": function() { return /* binding */ StyledTable; },
/* harmony export */   "vc": function() { return /* binding */ StyledBody; },
/* harmony export */   "x0": function() { return /* binding */ StyledHeaderH2; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22318);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        "px;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  margin-top: ",
        "px;\n  font-weight: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  ",
        ";\n  letter-spacing: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  margin-top: 40px;\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 34px;\n  letter-spacing: 0.05em;\n  color: ',
        ";\n  ",
        " {\n    max-width: 300px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0px;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  &::marker {\n    font-size: 10px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: underline;\n  ",
        ";\n  color: ",
        ";\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  margin-top: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-collapse: collapse;\n  text-align: right;\n  margin-top: 10px;\n  ",
        " {\n    display: block;\n    width: ",
        ";\n    overflow: auto;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n  ",
        " {\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: normal;\n  td:first-child {\n    font-size: 16px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  padding: 7px 7px;\n  font-size: 16px;\n  line-height: 1;\n  font-weight: normal;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 7px 5px;\n  border: 1px solid ",
        ";\n  font-size: 18px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}


var StyledHeaderH2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "BodyText__StyledHeaderH2",
    componentId: "sc-971327b-0"
})(_templateObject(), function(p) {
    return p.$position && "text-align: ".concat(p.$position);
}, function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin);
}, function(p) {
    return p.$fontSize ? "".concat(p.$fontSize, "px") : "24px";
}, function(p) {
    return p.$fontWeight ? p.$fontWeight : "400";
});
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledSubtitle",
    componentId: "sc-971327b-1"
})(_templateObject1(), function(p) {
    return p.$margin;
}, function(p) {
    return p.$fontWeight ? p.$fontWeight : "bold";
});
var StyledHeaderSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledHeaderSubtitle",
    componentId: "sc-971327b-2"
})(_templateObject2(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "20px";
}, function(p) {
    return p.$position && "text-align: ".concat(p.$position);
});
var StyledBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "BodyText__StyledBody",
    componentId: "sc-971327b-3"
})(_templateObject3(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "10px";
}, function(p) {
    return p.$position && "text-align: ".concat(p.$position);
}, function(p) {
    return p.$fontSize ? "".concat(p.$fontSize, "px") : "18px";
});
var StyledH3 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledH3",
    componentId: "sc-971327b-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledUl = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    displayName: "BodyText__StyledUl",
    componentId: "sc-971327b-5"
})(_templateObject5(), function(p) {
    return p.$padding && "padding-right: ".concat(p.$padding, "px");
});
var StyledLi = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    displayName: "BodyText__StyledLi",
    componentId: "sc-971327b-6"
})(_templateObject6(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "0px";
});
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    displayName: "BodyText__StyledLink",
    componentId: "sc-971327b-7"
})(_templateObject7(), function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin, "px");
}, function(p) {
    return p.$color ? p.$color : p.theme.colors.mazdaRed;
}, function(p) {
    return p.$display && "display: ".concat(p.$display);
}, function(p) {
    return p.$fontSize && "font-size: ".concat(p.$fontSize, "px");
});
var StyledSmallText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledSmallText",
    componentId: "sc-971327b-8"
})(_templateObject8(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "10px";
}, function(p) {
    return p.$fontWeight && "font-weight: ".concat(p.$fontWeight);
});
var StyledBody2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "BodyText__StyledBody2",
    componentId: "sc-971327b-9"
})(_templateObject9(), function(p) {
    return p.$fontSize && "font-size: ".concat(p.$fontSize, "px");
}, function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin, "px");
});
var StyledTable = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    displayName: "BodyText__StyledTable",
    componentId: "sc-971327b-10"
})(_templateObject10(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$width ? p.$width : "350px";
}, function(p) {
    return p.theme.breakpoints.down("xs");
}, function(p) {
    return p.$width ? p.$width : "90vw";
});
var StyledThead = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].thead.withConfig */ .ZP.thead.withConfig({
    displayName: "BodyText__StyledThead",
    componentId: "sc-971327b-11"
})(_templateObject11());
var StyledTr = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].tr.withConfig */ .ZP.tr.withConfig({
    displayName: "BodyText__StyledTr",
    componentId: "sc-971327b-12"
})(_templateObject12(), function(p) {
    return p.theme.colors.black;
});
var StyledTh = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].th.withConfig */ .ZP.th.withConfig({
    displayName: "BodyText__StyledTh",
    componentId: "sc-971327b-13"
})(_templateObject13(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.colors.darkGrey;
});
var StyledTd = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].td.withConfig */ .ZP.td.withConfig({
    displayName: "BodyText__StyledTd",
    componentId: "sc-971327b-14"
})(_templateObject14(), function(p) {
    return p.theme.colors.darkGrey;
});


/***/ }),

/***/ 78373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "My": function() { return /* binding */ keyFrameFadeOut; }
/* harmony export */ });
/* unused harmony exports keyframeFloating, keyframePulsateBig, keyframePulsateSmall, bounceCss, keyframeRotateInCenter, keyframeSize, keyframeSizeOpacity, keyFrameSizeToBig, keyFrameOpacity, keyFrameFadeIn, keyFrameCircle, keyFrameCircleFull */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% { transform: translate(0,  0px); }\n  50%  { transform: translate(0, -17px); }\n  100%   { transform: translate(0, -0px); }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    -webkit-transform: scale(1.2);\n            transform: scale(1.2);\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n   0%   {transform:translate3d(0,0,0)}\n  100%  {transform:translate3d(",
        "px,",
        "px,0)}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  left: ",
        "px;\n  top: ",
        "px;\n  animation: ",
        " 2.5s cubic-bezier(0.6, 0, 0.4, 1) 1s\n    infinite alternate;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    0% {\n      -webkit-transform: rotate(0);\n              transform: rotate(0);\n      opacity: 1;\n    }\n    60% {\n      -webkit-transform: rotate(360deg);\n              transform: rotate(360deg);\n      opacity: 1;\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n              transform: rotate(360deg);\n      opacity: 1;\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    width: 250px;\n    height: 200px;\n  }\n  to {\n    width: 150px;\n    height: 60px;\n\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nfrom {\n  width: 250px;\n  height: 200px;\n  opacity: 0;\n}\nto {\n  width: 150px;\n  height: 60px;\n  opacity: 0;\n}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nfrom {\n  width: 0px;\n  height: 0px;\n}\nto {\n  width: 100%;\n  height: 180px;\n}\n\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n0% { opacity:0; }\n100% { opacity:1; }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n0% { opacity:1; }\n100% { opacity:0; }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n0% { opacity:0; }\n100% { opacity:1; }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% { opacity: 0.9;  width: 0; height: 0; }\n  100% { opacity: 0.6; height: 300%; width: 300%; }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% { opacity: 0.9;   height: 100%; width: 100%; }\n  100% { opacity: 0.6; height: 100%; width: 100%; }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}

/* animation-name: example;
  animation-duration: 5s;
  animation-timing-function: linear;
  animation-delay: 2s;
  animation-iteration-count: infinite;
  animation-direction: alternate; */ /* div {
  animation: example 5s linear 2s infinite alternate;
} */ var keyframeFloating = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject());
var keyframePulsateBig = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject1());
var keyframePulsateSmall = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject2());
var keyframeBounceFloat = function(x, y) {
    return keyframes(_templateObject3(), x * 2, y * 2);
};
var bounceCss = function(x, y) {
    return css(_templateObject4(), x * -1, y * -1, keyframeBounceFloat(x, y));
};
var keyframeRotateInCenter = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject5());
/* animation example: */ /* const StyledBasketAnimation = styled.div<{ $doAnimation: boolean }>`
  animation: ${(props) =>
    props.$doAnimation
      ? css`
          ${keyframePulsateSmall} 0.3s ease-in-out 1;
        `
      : ""};
` */ /* @-webkit-keyframes rotate-in-center {
    0% {
      -webkit-transform: rotate(-360deg);
              transform: rotate(-360deg);
      opacity: 0;
    }
    100% {
      -webkit-transform: rotate(0);
              transform: rotate(0);
      opacity: 1;
    }
  }
  @keyframes rotate-in-center {
    0% {
      -webkit-transform: rotate(-360deg);
              transform: rotate(-360deg);
      opacity: 0;
    }
    100% {
      -webkit-transform: rotate(0);
              transform: rotate(0);
      opacity: 1;
    }
  } */ var keyframeSize = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject6());
var keyframeSizeOpacity = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject7());
var keyFrameSizeToBig = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject8());
var keyFrameOpacity = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject9());
var keyFrameFadeOut = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject10());
var keyFrameFadeIn = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject11());
var keyFrameCircle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject12());
var keyFrameCircleFull = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject13());


/***/ })

}]);